import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Badge, ButtonGroup, Card, CardBody, Col, Input, Row, Button } from 'reactstrap';
import PageHeader from '../common/PageHeader';
import TablePageSizeSelect from '../common/TablePageSizeSelect';
import MedDataTable from '../common/MedDataTable';
import apiBase from '../../apiConfig';
import useStoredTablePageSize from '../../hooks/useStoredTablePageSize';

const filterOptions = [
  { key: 'all', label: 'Barchasi' },
  { key: 'service', label: 'Kabinet' },
  { key: 'lab', label: 'Laboratoriya' },
  { key: 'imaging', label: 'UZI/Rentgen' }
];

const Services = () => {
  const [services, setServices] = useState([]);
  const [pageSize, setPageSize] = useStoredTablePageSize();
  const [type, setType] = useState('all');
  const [search, setSearch] = useState('');

  useEffect(() => {
    const fetchServices = async () => {
      const res = await axios.get(`${apiBase}/services.php`, { params: { type, search } });
      if (res.data.success) setServices(res.data.services);
    };

    fetchServices().catch(console.error);
  }, [type, search]);

  const rows = services.map(item => ({
    ...item,
    row_key: `${item.service_type}-${item.service_id}`
  }));

  const columns = [
    { dataField: 'service_type', text: 'Turi', sort: true, classes: 'align-middle text-uppercase' },
    { dataField: 'title', text: 'Nomi', sort: true, classes: 'align-middle font-weight-bold' },
    { dataField: 'category_name', text: 'Kategoriya', sort: true, classes: 'align-middle', formatter: value => value || '-' },
    { dataField: 'subcategory_name', text: 'Subkategoriya', sort: true, classes: 'align-middle', formatter: value => value || '-' },
    {
      dataField: 'price',
      text: 'Narx',
      sort: true,
      classes: 'align-middle',
      formatter: value => Number(value || 0).toLocaleString('ru-RU')
    },
    {
      dataField: 'active',
      text: 'Holat',
      sort: true,
      classes: 'align-middle',
      formatter: value => <Badge color={value ? 'soft-success' : 'soft-secondary'}>{value ? 'Faol' : 'Nofaol'}</Badge>
    }
  ];

  return (
    <>
      <PageHeader title="Xizmatlar" description="Kabinet, laboratoriya va imaging xizmatlari katalogi." className="mb-3" />
      <Card className="border-0 shadow-sm">
        <CardBody>
          <Row className="mb-3 align-items-center">
            <Col md="auto" className="mb-3 mb-md-0">
              <TablePageSizeSelect value={pageSize} onChange={setPageSize} className="med-table-page-size" />
            </Col>
            <Col md={4}>
              <Input
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Xizmat nomi bo'yicha qidirish"
                className="bg-200 border-0"
              />
            </Col>
            <Col md={5} className="text-md-right mt-3 mt-md-0">
              <ButtonGroup>
                {filterOptions.map(option => (
                  <Button
                    key={option.key}
                    color={type === option.key ? 'primary' : 'light'}
                    onClick={() => setType(option.key)}
                  >
                    {option.label}
                  </Button>
                ))}
              </ButtonGroup>
            </Col>
          </Row>
          <MedDataTable
            data={rows}
            columns={columns}
            keyField="row_key"
            pageSize={pageSize}
            paginationResetKey={`${type}-${search}`}
            noDataIndication={<div className="text-center py-4 text-500">Xizmatlar topilmadi</div>}
          />
        </CardBody>
      </Card>
    </>
  );
};

export default Services;
